<template>
  <v-dialog v-model="mostrar" persistent max-width="400px">
    <v-card>
      <v-card-title class="headline">{{titulo}}</v-card-title>
      <v-card-text v-html="texto"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small outlined @click="$emit('cancelar')">Cancelar</v-btn>
        <v-btn small dark color="blue-grey" @click="$emit('aceptar')">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    props:['mostrar','titulo', 'texto'],
    data() {
        return {
            
        };
    }
};
</script>